import { render, staticRenderFns } from "./content-notify.vue?vue&type=template&id=5d36f3c3&"
import script from "./content-notify.vue?vue&type=script&lang=js&"
export * from "./content-notify.vue?vue&type=script&lang=js&"
import style0 from "./content-notify.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports